module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_web.4859bd6d.svg";